import React from "react";
import './book-page.css';
import MoneyWorks from '../../Images/books/MoneyWorks.jpg';

const Review16 = () => {
  return (
    <div>
      <div className="book-page-box">
        <div className="book-header">
          <div className="book-img">
            <img src={MoneyWorks} alt="Money Works Cover" />
          </div>
          
          <div className="book-title">
            <h1>Money Works</h1>
            <p className="author">by <i>Abhijeet  Kolapkar </i></p>
            <p>Book review by <i>Priyal Gupta</i></p>
          </div>
        </div>
        
        <div className="book-para">
        <p>
    
        Every so often, a book reshapes our understanding of everyday concepts. <i>Money: The True Story of a Made-Up Thing by Jacob Goldstein</i> does just that, exploring the origins, evolution, and impact of money. While we see money as coins, cash, or digital figures, Goldstein reveals it as a shared belief system built on trust that shapes economies and societies.
                    <br></br><br></br>
                    
        <h3>The Evolution of Money</h3>            
            
        Money isn’t a fixed concept—it has transformed throughout history. It began with bartering, moved to metal coins, then paper bills, and now exists in digital form. Each shift was driven by society’s changing needs.
        <br/>
        Goldstein highlights key moments in financial history, such as:
        <ul>
            <li>
            Ancient Mesopotamians using clay tablets as an early form of banking.
            </li>
            <li>
            China pioneering paper money long before Europe.
            </li>
            <li>
            The Gold Standard’s influence before its downfall.
            </li>
            <li>
            How credit and debt shape modern economies.
            </li>
        </ul>
        <br></br>
        <h3>Is Money Even Real?</h3>            
            
        Money holds value only because we believe in it. A dollar bill is just paper—it’s trust that gives it worth. This idea extends to bank accounts, credit cards, and cryptocurrencies
        <br/>
        The book also examines:
        <ul>
            <li>
            How governments and banks control money supply and interest rates.
            </li>
            <li>
            The effects of inflation and deflation on economies.
            </li>
            <li>
            The rise of digital currencies like Bitcoin and their impact.
            </li>
        </ul>
        <br></br>

        <h3>Key Takeaways</h3> 
        <ol>
            <li>
            <b>Simplifying Finance For All:</b> Kolapkar breaks down complex financial concepts
            into simple terms, making his work relatable so as to be suitable for readers
            across all levels of financial literacy.
            </li>
            <li>
            <b>Actionable Strategies:</b> The book provides clear, step-by-step strategies for
            budgeting, saving, investing, and managing debt. He doesn’t just preach; he
            provides actionable steps, relatable anecdotes, and examples from everyday life
            to validate his points
            </li>
            <li>
            <b>Emphasis on Financial Literacy:</b> A standout feature of Money Works is its focus
            on financial education, aiming to bridge the gap between theoretical knowledge
            and practical application.
            </li>
            <li>
            <b>Holistic Approach:</b> The book doesn’t promise overnight success but delves into
            the psychology of money, emphasizing the importance of mindset and discipline
            in achieving financial well-being.
            </li>
            <li>
            <b>Tone and Style:</b> The conversational tone makes it feel less like a lecture and
            more like advice from a trusted friend. The chapters are concise, structured and
            concepts are well elaborated with supporting diagrams and flow charts.
            </li>
        </ol>
        <br></br>

        <h3>Final Thoughts</h3>
        That being said, readers who are already well-versed in personal finance might find some sections very basic or boring, as the book primarily caters to beginners. Additionally, more case studies or examples from varied income brackets could enhance its content further.
        <br></br>
        Overall, Money Works is an excellent resource for anyone who’s just started earning and doesn’t know what to do with their money. This book would help them take control of their finances hence a must-read.
         </p>

    </div>
    </div>
    </div>
                         
  );
}

export default Review16;

        
          
      
